import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CareersListComponent } from './careers-list/careers-list.component';
import { CareersCreateComponent } from './careers-create/careers-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: CareersListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: CareersCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'careers-create/:id',
        component: CareersCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CareersRoutingModule { }
